import classNames from "classnames";
import { createUseStyles } from "react-jss";

export interface ImageCardProps {
  className?: string;
  image: string;
  header: string;
  description: string;
  link?: string;
  linkLabel?: string;
}

const useStyles = createUseStyles({
  root: {
    backgroundColor: "#fff",
    padding: "30px",
    borderRadius: "5px",
    display: "flex",
    flexDirection: "row",
    marginBottom: "30px",
    "@media (max-width: 1024px)": {
      marginBottom: "30px",
      flexDirection: "column",
    },
  },
  image: {
    width: "35%",
    objectFit: "cover",
    "@media (max-width: 1024px)": {
      width: "100%",
    },
  },
  content: {
    marginLeft: "20px",
    "@media (max-width: 1024px)": {
      marginTop: "30px",
      marginLeft: "0px",
    },
  },
});

const ImageCard = ({
  className,
  image,
  header,
  description,
  link,
  linkLabel,
}: ImageCardProps) => {
  const classes = useStyles();
  return (
    <div className={classNames(classes.root, className)}>
      <img className={classes.image} alt="image-card" src={image} />
      <div className={classes.content}>
        <h3>{header}</h3>
        <p>{description}</p>
        {link && linkLabel && <a href={link}>{linkLabel}</a>}
      </div>
    </div>
  );
};

export default ImageCard;
